/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Thumbnail_Assigned_To_LabelInputs */



/**
* | output |
* | --- |
* | "Assigned To:" |
*
* @param {Explorer_Thumbnail_Assigned_To_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_thumbnail_assigned_to_label = /** @type {((inputs?: Explorer_Thumbnail_Assigned_To_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Thumbnail_Assigned_To_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Assigne a :")
	if (locale === "de") return /** @type {LocalizedString} */ ("Zugewiesen an:")
	if (locale === "it") return /** @type {LocalizedString} */ ("Assegnato a:")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Назначено:")
	if (locale === "es") return /** @type {LocalizedString} */ ("Asignado a:")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("指派给：")
	if (locale === "ja") return /** @type {LocalizedString} */ ("担当者:")
	if (locale === "hi") return /** @type {LocalizedString} */ ("को सौंपना:")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Atribuído a:")
	return /** @type {LocalizedString} */ ("Assigned To:")
});